import { Container } from "react-bootstrap";
import { useAppSelector } from "./app/hooks";
import GamesList from "./features/games/components/GameList";
import History from "./features/history/containers/History";

export default function Home() {
  let auth = useAppSelector((state) => state.auth);
  if (auth.user) {
    localStorage.setItem("authToken", auth.user.access_token);
  }

  return (
    <Container>
      <GamesList />
      <History />
    </Container>
  );
}
